export interface UpgradeActionPlan {
  id: string;
  plan_name: string;
  is_free?: boolean | null;
  price_monthly_sar?: number | null;
  standard_price_sar?: number | null;
  price_yearly_sar?: number | null;
  price_annual_sar?: number | null;
}

export type UpgradeBillingCycle = 'monthly' | 'yearly';

export function planPriceForBillingCycle(
  plan: UpgradeActionPlan,
  billingCycle: UpgradeBillingCycle,
): number | null {
  const candidates = billingCycle === 'yearly'
    ? [plan.price_yearly_sar, plan.price_annual_sar]
    : [plan.standard_price_sar, plan.price_monthly_sar];
  const price = candidates
    .map(Number)
    .find((candidate) => Number.isFinite(candidate) && candidate > 0);
  return price ?? null;
}

export function getEligibleUpgradePlans(
  plans: readonly UpgradeActionPlan[],
  currentPlan: UpgradeActionPlan | null | undefined,
  billingCycle: UpgradeBillingCycle,
): UpgradeActionPlan[] {
  if (!currentPlan) return [];
  const currentPrice = planPriceForBillingCycle(currentPlan, billingCycle);
  if (currentPrice == null) return [];

  return plans
    .filter((candidate) => {
      if (candidate.id === currentPlan.id || candidate.is_free) return false;
      const candidatePrice = planPriceForBillingCycle(candidate, billingCycle);
      return candidatePrice != null && candidatePrice > currentPrice;
    })
    .sort((left, right) =>
      (planPriceForBillingCycle(left, billingCycle) ?? Number.MAX_SAFE_INTEGER) -
      (planPriceForBillingCycle(right, billingCycle) ?? Number.MAX_SAFE_INTEGER));
}
